// Dev-only override so the Konsta native shell can be previewed in a normal browser
// (e.g. `?nativePreview=ios` or `?nativePreview=android`). Stripped from production
// builds, and the real Capacitor check always wins inside the native app.
const devNativeOverride = () => {
  if (typeof window === 'undefined') return null
  if (process.env.NODE_ENV === 'production') return null
  const p = new URLSearchParams(window.location.search).get('nativePreview')
  return p === 'ios' || p === 'android' ? p : null
}

/**
 * Zentrale Erkennung, ob die App in der nativen Capacitor-Shell (iOS/Android) läuft.
 * Capacitor injiziert `window.Capacitor` nur in der nativen WebView; im normalen Browser
 * fehlt es, sodass jedes native Feature auf sein Web-Äquivalent zurückfällt (Progressive
 * Enhancement). Im Dev-Build erzwingt der `?nativePreview=`-Parameter ebenfalls `true`.
 *
 * @returns {boolean} `true` in der nativen App (oder Dev-Preview), sonst `false`.
 */
export const isNative = () =>
  !!devNativeOverride() ||
  (typeof window !== 'undefined' &&
  !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform()))

/**
 * Liefert die aktuelle Plattform.
 * @returns {'ios'|'android'|'web'} Native Plattform bzw. `'web'` im Browser.
 */
export const platform = () =>
  (typeof window !== 'undefined' && window.Capacitor?.getPlatform?.()) ||
  devNativeOverride() ||
  'web'

/**
 * Bildet die Plattform auf eines der beiden Konsta-UI-Themes ab. Android → `'material'`,
 * alles andere (iOS und Web mit aktivem Konsta) → `'ios'`.
 * @returns {'ios'|'material'} Das zu verwendende Konsta-Theme.
 */
export const konstaTheme = () => (platform() === 'android' ? 'material' : 'ios')
